<div class="align-items-center center">
  <div class="row">
    <div class="d-flex justify-content-center">
      <div class="text-center">
        <img src="assets/images/not-found.svg" [alt]="text" class="mb-3" />

        <div class="font-size-16" *ngIf="!!htmlTextTemplate; else plainTextTemplate">
          <ng-container *ngTemplateOutlet="htmlTextTemplate"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #plainTextTemplate>
  <p class="font-size-16">
    {{ text }}
  </p>
</ng-template>
